declare namespace $ {

	type $mol_text__text_shm_hitalama_components_version_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_version['note'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_hitalama_components_version_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_version['details'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_link__uri_shm_hitalama_components_version_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_version['commit_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_shm_hitalama_components_version_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_components_version['commit_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__target_shm_hitalama_components_version_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['target'] >
	>
	export class $shm_hitalama_components_version extends $mol_page {
		note( ): string
		Note( ): $mol_text
		details( ): string
		Details( ): $mol_text
		commit_uri( ): string
		commit_title( ): string
		Commit( ): $mol_link
		entry( ): $shm_hitalama_components_versions_entry
		minimal_width( ): number
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=version.view.tree.d.ts.map